<div class="container" [formGroup]="inputForm">
  <div class="row">
    <div class="col col-12">
      <mat-form-field class="w-100">
        <mat-label>Send Limit</mat-label>
        <input
          matInput
          formControlName="limit"
          type="number"
          placeholder="Send Limit" />
      </mat-form-field>
    </div>
  </div>
</div>
